import { Capability } from 'homey-lib/webpack/index.js';

import { DeviceSettings } from '../../config/DeviceSettings';
import { zoneActivityCapabilities } from '../../config/zoneActivityCapabilities';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { theme } from '../../theme/theme';
import styles from './IndicatorAlarmSpecific.module.css';

const ACTIVE_ALARM_COLOR = '#ff8400';
const ACTIVE_ALARM_BACKGROUND_COLOR = '#ff84001a';

export function IndicatorAlarmSpecific(props) {
  const { i18n } = useI18n();
  const [value] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: props.capabilityId,
  });

  const zoneActivityEnabled = props.device.settings[DeviceSettings.ZoneActivityDisabled] === false;
  const baseCapabilityId = Capability.getBaseId(props.capabilityId);
  const capabilityObj = props.device.capabilitiesObj?.[props.capabilityId];
  const isZoneActivityCapability =
    zoneActivityEnabled && zoneActivityCapabilities.has(baseCapabilityId);

  if (isZoneActivityCapability === true) {
    if (value === true) {
      return (
        <div
          className={styles.root}
          style={{
            '--prop-icon-background-color': theme.color.blue_o_10,
            '--prop-icon-color': theme.color.highlight,
            '--prop-text-color': theme.color.highlight,
          }}
        >
          <span className={styles.icon} />
          <div className={styles.statusText}>
            {capabilityObj?.titleShort ??
              capabilityObj?.title ??
              i18n.messageFormatter('device.alarm.active')}
          </div>
        </div>
      );
    }

    return null;
  }

  if (value !== true) {
    return null;
  }

  const tone = getAlarmTone(baseCapabilityId);
  const label = capabilityObj?.titleShort ?? capabilityObj?.title ?? props.capabilityId;

  return (
    <div
      className={styles.root}
      style={{
        '--prop-icon-background-color': tone.backgroundColor,
        '--prop-icon-color': tone.color,
        '--prop-text-color': tone.color,
      }}
    >
      <span className={styles.icon} />
      <div className={styles.statusText}>{label}</div>
    </div>
  );
}

function getAlarmTone(baseCapabilityId) {
  if (
    baseCapabilityId === 'alarm_smoke' ||
    baseCapabilityId === 'alarm_fire' ||
    baseCapabilityId === 'alarm_co'
  ) {
    return {
      backgroundColor: '#d81c1d1a',
      color: theme.color.error,
    };
  }

  return {
    backgroundColor: ACTIVE_ALARM_BACKGROUND_COLOR,
    color: ACTIVE_ALARM_COLOR,
  };
}
